import baseWs from '../generic/baseWs'
import _ from 'lodash';

export function fetchUserProfile(){
    return baseWs.post('/api/services/app/userProfile/FetchUserProfile', {})
     .then(res => {
         return res;
     })
     .catch(err => {
         if (!_.isEmpty(err.response)){
             console.log('Error')
         }
         console.log('Error getting profile data: ' + err);
         throw err;
     })
}

export function updateUserProfile(update){
    return baseWs.post('/api/services/app/userProfile/UpdateUserProfile', {...update})
     .then(res => {
         return res;
     })
     .catch(err => {
         if (!_.isEmpty(err.response)){
             console.log('Error')
         }
         console.log('Error updating profile data: ' + err);
         throw err;
     })
}
